export default __webpack_public_path__ + "static/emma-e69a782dcc2ec84399f7e3d4cb9a11c5.jpg";